import { render, staticRenderFns } from "./mCopyright.vue?vue&type=template&id=0aed3525&scoped=true&"
import script from "./mCopyright.vue?vue&type=script&lang=js&"
export * from "./mCopyright.vue?vue&type=script&lang=js&"
import style0 from "./mCopyright.vue?vue&type=style&index=0&id=0aed3525&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed3525",
  null
  
)

export default component.exports